import type { LaneChooserGameTheme } from '@/features/laneChooser/game/types';

type LottieSource = object;

type ThemeLottieVariants = {
	mobile: LottieSource;
	tablet?: LottieSource;
	tabletPortrait?: LottieSource;
	tabletLandscape?: LottieSource;
	desktop: LottieSource;
};

type ThemeStartScreenImages = {
	mobile: string;
	tablet: string;
	desktop: string;
};

export type LaneChooserTheme = {
	key: LANE_CHOOSER_THEME_KEYS;
	game: LaneChooserGameTheme;
	images: {
		progressEnd: string;
		startScreen?: ThemeStartScreenImages;
	};
	animations: {
		endScreen: {
			success: ThemeLottieVariants;
			failed: ThemeLottieVariants;
		};
		startScreen: {
			mapUnfold: LottieSource;
			background?: ThemeLottieVariants;
		};
	};
};

export enum LANE_CHOOSER_THEME_KEYS {
	LAKE = 'lake',
	FOREST = 'forest',
	MOUNTAIN = 'mountain',
	DESERT = 'desert',
	PARK = 'park',
}

export const defaultThemeKey = LANE_CHOOSER_THEME_KEYS.LAKE;
